export default __webpack_public_path__ + "emptyOrderListIcon.1f96d90545f0886085a44dc29185c8fd.png";